<template>
  <div class="tab-panel-body">
    <!-- Header -->
    <div class="config-section-header">
      <div class="config-section-header__left">
        <v-icon small class="mr-2" color="text_secondary">mdi-map</v-icon>
        <span class="config-section-label">Contagem de colaborações por UF</span>
      </div>
    </div>

    <!-- Settings -->
    <div class="mapa-settings">
      <!-- Start -->
      <div class="mapa-time-block">
        <span class="mapa-time-title">
          <v-icon x-small class="mr-1" color="primary">mdi-play</v-icon>
          Início
        </span>
        <div class="mapa-time-row">
          <div class="mapa-time-field">
            <label class="mapa-label">Dia da semana</label>
            <v-select
              v-model="weekDayStartCount"
              :items="weekDays"
              dense
              solo
              flat
              hide-details
              placeholder="Selecione"
              background-color="surface_tertiary"
            />
          </div>
          <div class="mapa-time-field mapa-time-compact">
            <label class="mapa-label">Hora</label>
            <v-select
              v-model="startHour"
              :items="hours"
              dense
              solo
              flat
              hide-details
              placeholder="00"
              background-color="surface_tertiary"
            />
          </div>
          <div class="mapa-time-field mapa-time-compact">
            <label class="mapa-label">Min</label>
            <v-select
              v-model="startMinute"
              :items="minutes"
              dense
              solo
              flat
              hide-details
              placeholder="00"
              background-color="surface_tertiary"
            />
          </div>
        </div>
      </div>

      <!-- End -->
      <div class="mapa-time-block">
        <span class="mapa-time-title">
          <v-icon x-small class="mr-1" color="error">mdi-stop</v-icon>
          Fim
        </span>
        <div class="mapa-time-row">
          <div class="mapa-time-field">
            <label class="mapa-label">Dia da semana</label>
            <v-select
              v-model="weekDayEndCount"
              :items="weekDays"
              dense
              solo
              flat
              hide-details
              placeholder="Selecione"
              background-color="surface_tertiary"
            />
          </div>
          <div class="mapa-time-field mapa-time-compact">
            <label class="mapa-label">Hora</label>
            <v-select
              v-model="endHour"
              :items="hours"
              dense
              solo
              flat
              hide-details
              placeholder="00"
              background-color="surface_tertiary"
            />
          </div>
          <div class="mapa-time-field mapa-time-compact">
            <label class="mapa-label">Min</label>
            <v-select
              v-model="endMinute"
              :items="minutes"
              dense
              solo
              flat
              hide-details
              placeholder="00"
              background-color="surface_tertiary"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Save -->
    <div class="mapa-footer">
      <v-btn
        color="primary"
        @click="updateWindowTimeCounting"
        :loading="loadingSave"
        class="modal-btn-confirm"
      >
        <v-icon small class="mr-1">mdi-check</v-icon>
        Salvar
      </v-btn>
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";

export default {
  name: "ConfigTabMapa",
  props: {
    codProducao: { type: Number, required: true },
    producao: { type: Object, required: true },
  },
  data() {
    return {
      weekDays: [
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
        "Domingo",
      ],
      hours: Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0")),
      minutes: Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0")),
      weekDayStartCount: null,
      weekDayEndCount: null,
      startHour: null,
      startMinute: null,
      endHour: null,
      endMinute: null,
      loadingSave: false,
    };
  },
  created() {
    if (!this.producao) return;
    this.weekDayStartCount = this.producao.week_day_start_count_messages;
    this.weekDayEndCount = this.producao.week_day_end_count_messages;
    this.parseTime(this.producao.start_time_count_messages, "start");
    this.parseTime(this.producao.end_time_count_messages, "end");
  },
  methods: {
    parseTime(timeStr, prefix) {
      if (timeStr && timeStr.length >= 5) {
        const [h, m] = timeStr.slice(0, 5).split(":");
        this[`${prefix}Hour`] = h;
        this[`${prefix}Minute`] = m;
      }
    },
    formatTime(hour, minute) {
      if (hour == null || minute == null) return null;
      return `${hour}:${minute}`;
    },
    async updateWindowTimeCounting() {
      this.loadingSave = true;
      try {
        await apiClient.patch(`/updateWindowTimeCountingMessages/${this.codProducao}`, {
          weekDayStart: this.weekDayStartCount,
          weekDayEnd: this.weekDayEndCount,
          timeStart: this.formatTime(this.startHour, this.startMinute),
          timeEnd: this.formatTime(this.endHour, this.endMinute),
        });
        this.$toast.success("Atualizações salvas com sucesso.");
      } catch (error) {
        this.$toast.error("Erro ao atualizar configuração.");
      } finally {
        this.loadingSave = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Settings */
.mapa-settings {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mapa-time-block {
  background: var(--sc-surface-tint-subtle);
  border-radius: var(--sc-radius-lg);
  padding: 16px;
  border: 1px solid var(--sc-border-subtle);
}

.mapa-time-title {
  display: flex;
  align-items: center;
  font-size: var(--sc-text-base);
  font-weight: 600;
  color: var(--v-text_primary-base);
  margin-bottom: 12px;
}

.mapa-time-row {
  display: flex;
  gap: 12px;
}

.mapa-time-field {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mapa-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--v-text_secondary-base);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mapa-time-compact {
  max-width: 90px;
  flex: 0 0 90px;
}

/* Footer */
.mapa-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--sc-border-subtle);
}

</style>
